<script setup lang="ts">
const props = defineProps<{
	iconName: string
	featureName: string
	title: string
}>()
</script>

<template>
	<article class="number-one-feature">
		<div class="number-one-feature__container">
			<GlobalIcon class="number-one-feature__icon" :name="props.iconName" :width="20" />
			<span class="number-one-feature__name">{{ props.featureName }}</span>
		</div>
		<h3 class="number-one-feature__title" v-html="props.title"></h3>
	</article>
</template>

<style lang="scss">
@import './Feature';
</style>
